import { createContext, useContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';

export interface DisclaimerConfiguration {
  includeLuminaryDisclaimer: boolean;
  presentationCoverDisclaimerTitle: string;
  presentationCoverDisclaimerBody: string;
  presentationFooterDisclaimerTitle: string;
  presentationFooterDisclaimerBody: string;
  presentationStandaloneDisclaimerTitle: string;
  presentationStandaloneDisclaimerBody: string;
}

export interface TenantPresentationConfigurationContext {
  legalDisclaimers: DisclaimerConfiguration | null;
}

export const TenantPresentationConfigurationContext =
  createContext<TenantPresentationConfigurationContext>({
    // We set this to undefined so when we try to use the context outside of the provider
    // the value is undefined.
    legalDisclaimers: null,
  });

export const useGuardedTenantPresentationConfigurationContext = () => {
  return useGuardedContext(
    TenantPresentationConfigurationContext,
    'TenantPresentationConfigurationProvider'
  );
};

export const useUnguardedTenantPresentationConfigurationContext = () => {
  return useContext(TenantPresentationConfigurationContext);
};
